export let ToolHandedness = {
    NONE: null,
    LEFT: "left",
    RIGHT: "right"
};

export let ToolInputSourceType = {
    NONE: null,
    GAMEPAD: 0,
    TRACKED_HAND: 1
};